import { DecimalPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { AB_CURRENCY_FORMAT } from '../constants';

@Pipe({
  name: 'abCurrency',
})
export class AbCurrencyPipe extends DecimalPipe implements PipeTransform {
  transform(value: any): any {
    return (
      super.transform(value.amount, AB_CURRENCY_FORMAT) +
      ' ' +
      value.currencyCode
    );
  }
}
